import { z } from 'zod';

import type { UserCompanyNotificationDto } from '@/services/ws-comments/src/main/resources/rest-api';
import type { DateRangeType } from '@/js/libs/ui/src/V2';

import type { GridTableColumnComponentProps, GridTableColumn } from 'src/types.ts';

export type NotificationsFilterFields = {
  showRead: boolean;
  search: string;
  period: DateRangeType | null;
};

export const notificationsQueryParamsSchema = z.object({
  search: z.string().optional(),
});

export type NotificationsQueryParams = z.infer<typeof notificationsQueryParamsSchema>;

export type SystemNotificationColumnName = 'isRead' | 'title' | 'startDate';

export interface SystemNotificationColumnProps extends GridTableColumnComponentProps<SystemNotificationColumnName> {
  notification: UserCompanyNotificationDto;
  isMobile: boolean;
  ellipsizeLength: number;
}

export type SystemNotificationColumn = GridTableColumn<SystemNotificationColumnName, SystemNotificationColumnProps>;
